export const QID_WHY_COMPARING = 'qid_why_comparing'
export const QID_LOCATIONS = 'qid_locations'
export const QID_DEVICES = 'qid_devices'
export const QID_APP_USERS = 'qid_app_users'
export const QID_SUMMARY = 'qid_summary'
